<template>
<div class="chapter">
<div class="inner_page">
<h2 style="font-family: Calisto MT;">Dead Goes the Neighbourhood</h2>
<ul style="font-family: Calisto Mt; margin-left: -10px; margin-top: 20px; font-weight: normal !important;">
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Dedication</a></li>
<li><a href="#/index_split_002#toc_id_3">Copyright Information ©</a></li>
<li><a href="#/index_split_003#id_Toc168055283">Chapter One</a></li>
<li><a href="#/index_split_004#id_Toc168055284">Chapter Two</a></li>
<li><span href="#/index_split_005#id_Toc168055285" title="Link target outside of Sample">Chapter Three</span></li>
<li><span href="#/index_split_006#id_Toc168055286" title="Link target outside of Sample">Chapter Four</span></li>
<li><span href="#/index_split_007#id_Toc168055287" title="Link target outside of Sample">Chapter Five</span></li>
<li><span href="#/index_split_008#id_Toc168055288" title="Link target outside of Sample">Chapter Six</span></li>
<li><span href="#/index_split_009#id_Toc168055289" title="Link target outside of Sample">Chapter Seven</span></li>
<li><span href="#/index_split_010#id_Toc168055290" title="Link target outside of Sample">Chapter Eight</span></li>
<li><span href="#/index_split_011#id_Toc168055291" title="Link target outside of Sample">Chapter Nine</span></li>
<li><span href="#/index_split_012#id_Toc168055292" title="Link target outside of Sample">Chapter Ten</span></li>
<li><span href="#/index_split_013#id_Toc168055293" title="Link target outside of Sample">Chapter Eleven</span></li>
<li><span href="#/index_split_014#id_Toc168055294" title="Link target outside of Sample">Chapter Twelve</span></li>
<li><span href="#/index_split_015#id_Toc168055295" title="Link target outside of Sample">Chapter Thirteen</span></li>
<li><span href="#/index_split_016#id_Toc168055296" title="Link target outside of Sample">Chapter Fourteen</span></li>
<li><span href="#/index_split_017#id_Toc168055297" title="Link target outside of Sample">Chapter Fifteen</span></li>
<li><span href="#/index_split_018#id_Toc168055298" title="Link target outside of Sample">Chapter Sixteen</span></li>
<li><span href="#/index_split_019#id_Toc168055299" title="Link target outside of Sample">Tying Up Loose Ends</span></li>
<li><span href="#/index_split_020#id_Toc168055300" title="Link target outside of Sample">Last Day in Brumby Flat</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2c27b2ee